import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';

function Hero1() {
    const HeroBg1 = '/hero-bg-protopath.jpg';

    return (
        <section className="hero-slide-wrapper hero-1">
            <Swiper className="hero-slider-active owl-carousel">
                <SwiperSlide>
                    <div
                        className="single-slide bg-cover"
                        style={{ backgroundImage: `url(${HeroBg1})` }}
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-lg-8 col-xl-6">
                                    <div className="hero-contents">
                                        <h1 style={{
                                            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(0, 0, 0, 0.6)'
                                        }}>Industrial Design Excellence</h1>
                                        <p style={{
                                            textShadow: '1px 1px 3px rgba(0, 0, 0, 0.8), 0 0 8px rgba(0, 0, 0, 0.6)'
                                        }}>From concept to reality - Expert CAD design, 3D scanning, and manufacturing solutions</p>
                                        <a href="/#services" className="theme-btn">
                                            Our Services{' '}
                                            <BsArrowRight style={{ marginLeft: '10px' }} />
                                        </a>
                                        <a href="/#about" className="theme-btn black">
                                            Learn More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div
                        className="single-slide bg-cover"
                        style={{ backgroundImage: `url(${HeroBg1})` }}
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-lg-8 col-xl-6">
                                    <div className="hero-contents">
                                        <h1 style={{
                                            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(0, 0, 0, 0.6)'
                                        }}>Manufacturing Consulting</h1>
                                        <p style={{
                                            textShadow: '1px 1px 3px rgba(0, 0, 0, 0.8), 0 0 8px rgba(0, 0, 0, 0.6)'
                                        }}>Production optimisation, ISO conformance, and high-efficiency labour planning</p>
                                        <a href="/#services" className="theme-btn">
                                            Our Services{' '}
                                            <BsArrowRight style={{ marginLeft: '10px' }} />
                                        </a>
                                        <a href="/#contact" className="theme-btn black">
                                            Get a Quote
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
        </section>
    );
}

export default Hero1;
